import { render, staticRenderFns } from "./MessageTemplate.vue?vue&type=template&id=0c42eb17&scoped=true&"
import script from "./MessageTemplate.vue?vue&type=script&lang=ts&"
export * from "./MessageTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./MessageTemplate.vue?vue&type=style&index=0&id=0c42eb17&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c42eb17",
  null
  
)

export default component.exports